import { useContext } from 'react';
import { AppContext } from '../DataProviders/AppStateProvider';

/**
 * Counter Handler
 *
 * Helps to track the current steps in the view, except the intro and result steps.
 *
 * @returns {{counterCurrent: number, counterTotal: number}}
 */
const useDocTitle = () => {
  const { appData } = useContext(AppContext);

  const setDocTitle = (title = null) => document.title =
    ( title ) ? appData.document.title + ' - ' + title : appData.document.title

  const resetDocTitle = () => setDocTitle();

  return {
    setDocTitle,
    resetDocTitle
  };
};

export default useDocTitle
